import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/jquery-plugin.autocomplete.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/Collapse.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/CustomEventLoader.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/DoubleTapToGo.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/IntersectionObserverpolyfill.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/modernizr.3.5.0.min.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/shariff.min.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/Stickybits.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/libs/Transition.js"

import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/BackendDetection.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/BrowserDetection.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/ProductPage.js"
import "../../../../Juzo.NodeTypes/Resources/Private/JavaScript/Head/DeviceDetection.js"

import "../../../../../Packages/Plugins/TechDivision.ResponsiveImages/Resources/Public/Scripts/Scripts.js"
import "../../../../../Packages/Plugins/TechDivision.Video/Resources/Private/JavaScript/Video"
import "../../../../../Packages/Plugins/TechDivision.Structure/Resources/Public/Scripts/Scripts.js"
import "../../../../../Packages/Plugins/TechDivision.Carousel/Resources/Public/JavaScript/Scripts.js"
